import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Table from "./Table/Table";
import {request} from "../helper/APIUtils";
import {showAxiosError} from "../helper/helper";

class DownloadRequestModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			searching: false,
			total: 0,
			page: 0,
			size: 10,
			isMobile:window.innerWidth > 991 ? false : true
		};
		this.fetchDownloadRequests = this.fetchDownloadRequests.bind(this);
	}

	fetchDownloadRequests(accessor, direction, page, size) {
		let self = this;
		let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=recordId,desc';
		let params = {
			url: '/user/downloadRequests?page=' + page + '&size=' + size + sortStr,
			method: "get",
		};
		self.setState({loading: true, searching: true});
		request(params).then(function (response) {
			console.log(response)
			self.setState({
				downloadRequests: response.data.content,
				page: page,
				size: size,
				total: response.data.totalElements,
				loading: false,
				searching: false
			})
		}).catch(function (error) {
			self.setState({buttonStyle: null, loading: false, searching: false});
			showAxiosError(error);
		});
	}

	downloadExcelFile(row) {
		let uuid = row.uuid;
		let params = {
			url: '/user/downloadExcelFile',
			responseType: 'arraybuffer',
			method: "post",
			data: row.uuid
		};

		request(params).then(function (response) {
			console.log(response);
			let blob = new Blob([response.data], {type: response.headers["content-type"]});
			let urlCreator = window.URL || window.webkitURL;
			let url = urlCreator.createObjectURL(blob);
			let a = document.createElement("a");
			document.body.appendChild(a);
			a.style = "display: none";
			a.href = url;
			a.download = uuid + ".xlsx";
			a.click();

		}).catch(function (error) {
			if (error.response === undefined) {
				showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
			} else {
				let enc = new TextDecoder("utf-8");
				showAxiosError({message: enc.decode(error.response.data)});
			}
		});
	}


	defineAccessor(row) {
		let accessor = {};
		switch (row.documentKey) {
			case 'inbox':
			case 'inboxTransfer':
			case 'eDespatchInbox':
				accessor.targetId = row.sourceId;
				accessor.targetTitle = row.sourceTitle;
				break;
			case 'outbox':
			case 'outboxTransfer':
			case 'eArchive':
			case 'eArchiveTransfer':
			case 'mVoucher':
			case 'sVoucher':
			case 'eDespatchOutbox':
				accessor.targetId = row.destinationId;
				accessor.targetTitle = row.destinationTitle;
				break;
		}
		return accessor;
	}

	render() {

		const columns = [
			{
				Header: "Bekleyen Doküman",
				accessor: "documentType",
				sortable: false,
			},
			{
				Header: "Tarih Aralığı",
				accessor: "dateInterval",
				sortable: false,
			},
			{
				Header: "Vkn/Tckn",
				title : "Vkn/Tckn",
				accessor: '',
				sortable: false,
				Cell: row => (
					<label>{this.defineAccessor(row).targetId}</label>
				)
			},
			{
				Header: "Unvan",
				title : "Unvan",
				accessor: '',
				sortable: false,
				Cell: row => (
					<label>{this.defineAccessor(row).targetTitle}</label>
				)

			},
			{
				Header: "Arşiv Durumu",
				title: "Arşiv Durumu",
				accessor: "archiveStatus",
				sortable: false,
			},
			{
				Header: "Cevap Durumu",
				title: "Cevap Durumu",
				accessor: "responseCode",
				sortable: false,
			},
			{
				Header: "Senaryo Türü",
				accessor: "documentProfile",
				sortable: false,
			},
			{
				Header: "Fatura Türü",
				accessor: "invoiceTypeCode",
				sortable: false,
			},
			{
				Header: "İptal Durumu",
				accessor: "cancelled",
				sortable: false
			},
			{
				Header: "Durum",
				accessor: '',
				title: "Durum",
				sortable: false,
				Cell: row => (
					<label>{row.state === 1 ? 'Belge Hazırlanıyor' :
						(row.state === 2 ? 'Belge İndirilebilir' :
							(row.state === 3 ? 'Belge İndirilebilir / (Daha önce indirildi)' : ''))}</label>
				)
			},
			{
				Header: "İşlemler",
				title: "İşlemler",
				accessor: '',
				sortable: false,
				Cell: row => (
					<div>
						{this.state.isMobile && <span style={{width : '1px',maxWidth:'1px',visibility:'hidden'}}>|</span>}
						{(row.state === 2 || row.state === 3) &&
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="İndir"
								style={{background: 'rgba(70, 255, 150, 1), rgb(22, 224, 38))'}}
								rel="tooltip" className="Btn btn-icon" onClick={() => this.downloadExcelFile(row)}>
							<i className="BtnIcon fa fa-download"/>
						</button>}
					</div>
				)
			}
		];

		return (
			<Modal isOpen={this.props.isOpen} size='xl'>
				<ModalHeader toggle={this.props.close}>Bekleyen İndirmeleriniz</ModalHeader>
				<ModalBody>
					<Table
						columns={columns}
						content={this.state.downloadRequests ? this.state.downloadRequests : []}
						total={this.state.total}
						page={this.state.page}
						size={this.state.size}
						loading={this.state.loading}
						options={['5', '10', '20']}
						fetchData={this.fetchDownloadRequests}/>
				</ModalBody>
				<ModalFooter></ModalFooter>
			</Modal>
		)
	}
}

export default DownloadRequestModal;